import { render, staticRenderFns } from "./AddressComparison.vue?vue&type=template&id=c808d06a&scoped=true&"
import script from "./AddressComparison.vue?vue&type=script&lang=js&"
export * from "./AddressComparison.vue?vue&type=script&lang=js&"
import style0 from "./AddressComparison.vue?vue&type=style&index=0&id=c808d06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c808d06a",
  null
  
)

export default component.exports